<div class="dialog-header">
  <h2>Upgrade</h2>
  <button class="x-btn" (click)="close()">&#10005;</button>
</div>

<div class="dialog-body">
  <!-- Plan -->
  <div class="form-group">
    <label>Plan</label>
    <select [(ngModel)]="form.plan" (ngModelChange)="onPlanChange()">
      <option *ngFor="let p of plans" [value]="p.value">{{ p.label }}</option>
    </select>
  </div>

  <!-- Current Plan Price -->
  <div class="form-group">
    <label>Current Plan Price</label>
    <input
      type="number"
      [(ngModel)]="form.currentPlanPrice"
      readonly
      class="readonly-input"
    />
  </div>

  <!-- New Plan Price -->
  <div class="form-group">
    <label>New Plan Price</label>
    <input
      type="number"
      [(ngModel)]="form.newPlanPrice"
      (ngModelChange)="calcRequired()"
    />
  </div>

  <!-- Required Payment -->
  <div class="form-group">
    <label>Required Payment</label>
    <input
      type="number"
      [(ngModel)]="form.requiredPayment"
      readonly
      class="readonly-input"
    />
  </div>

  <!-- Cash Paid -->
  <div class="form-group">
    <label>Cash Paid</label>
    <input type="number" [(ngModel)]="form.cashPaid" />
  </div>

  <!-- Visa Paid -->
  <div class="form-group">
    <label>Visa Paid</label>
    <input type="number" [(ngModel)]="form.visaPaid" />
  </div>

  <!-- Contactless Cash Paid -->
  <div class="form-group">
    <label>Contactless Cash Paid</label>
    <input type="number" [(ngModel)]="form.contactlessCashPaid" />
  </div>

  <!-- Benefits Grid -->
  <div class="benefits-grid">
    <div class="benefit-item" *ngFor="let b of benefits">
      <label>{{ b.label }}</label>
      <input type="number" [(ngModel)]="b.value" />
    </div>
  </div>

  <!-- Attendance Schedule -->
  <div class="attendance-section">
    <div class="attendance-row" *ngFor="let day of attendanceDays">
      <div class="form-group half">
        <label>Attendance {{ day.name }} From</label>
        <input type="time" [(ngModel)]="day.from" />
      </div>
      <div class="form-group half">
        <label>Attendance {{ day.name }} To</label>
        <input type="time" [(ngModel)]="day.to" />
      </div>
    </div>
  </div>

  <!-- Due Date -->
  <div class="form-group">
    <label>Due Date</label>
    <input type="date" [(ngModel)]="form.dueDate" />
  </div>

  <!-- Due Note -->
  <div class="form-group">
    <label>Due Note</label>
    <textarea [(ngModel)]="form.dueNote" rows="3"></textarea>
  </div>

  <!-- Note -->
  <div class="form-group">
    <label>Note</label>
    <textarea [(ngModel)]="form.note" rows="3"></textarea>
  </div>
</div>

<div class="dialog-footer">
  <button class="close-btn" (click)="close()">Close</button>
  <button class="submit-btn" (click)="submit()">Submit</button>
</div>
